import { RouteConfig } from 'vue-router'
import { isAuthenticated } from '@/middlewares/isAuthenticated'
import { isRoleAllowed } from '@/middlewares/isRoleAllowed'
import { Role } from '@/interfaces/dashboard'

const routes: Array<RouteConfig> = [
  {
    path: '/templates',
    name: 'Templates',
    meta: {
      middlewares: [isAuthenticated, isRoleAllowed],
      allowedRoles: [Role.ADMIN, Role.OFFER_ADMIN, Role.ANALISE],
      layout: 'dashboard',
      title: 'Templates | SMU Investimentos'
    },
    component: () => import(/* webpackChunkName: "documents" */ '../views/pages/templates/index.vue')
  }
]

export default routes
